/** Pinpoint / Sumo application name for auth-shell login and servicing events. */
export const AUTH_APPLICATION = 'AuthCustomerSrvApp';
